import React, { useEffect, useState } from 'react';
import { Check, Loader2, Mic } from 'lucide-react';
import { apiService } from '../../services/api';

// Empreinte vocale tirée de cette réunion : proposée quand une voix du transcript est attribuée à la personne
// connectée, que l'audio est encore là (7 jours) et qu'elle y parle seule assez longtemps. Consentement explicite.

const VoiceFromMeeting = ({ meetingId, refreshKey }) => {
  const [info, setInfo] = useState(null);
  const [enrolled, setEnrolled] = useState(false);
  const [asking, setAsking] = useState(false);
  const [consent, setConsent] = useState(false);
  const [state, setState] = useState(null); // 'sending' | 'queued' | message d'erreur

  useEffect(() => {
    let alive = true;
    Promise.all([apiService.get(`/voice-profile/from-meeting/${meetingId}`), apiService.get('/voice-profile')])
      .then(([found, profile]) => {
        if (!alive) return;
        setInfo(found);
        setEnrolled(Boolean(profile.enrolled));
      })
      .catch(() => alive && setInfo(null));
    return () => { alive = false; };
  }, [meetingId, refreshKey]);

  if (!info?.possible) return null;
  const send = async () => {
    setState('sending');
    try {
      await apiService.post(`/voice-profile/from-meeting/${meetingId}?consent=true`, {});
      setState('queued');
      setAsking(false);
    } catch (err) {
      setState(err.message);
    }
  };

  if (state === 'queued') {
    return <span className="flex items-center gap-1 text-emerald-600"><Check className="h-3 w-3" /> Empreinte en calcul sur le Mac (quelques minutes)</span>;
  }
  return (
    <span className="relative">
      <button type="button" onClick={() => setAsking((v) => !v)}
        title={`${Math.round(info.seconds)} s où tu parles seul dans cette réunion`}
        className="flex items-center gap-1 hover:text-violet-600">
        <Mic className="h-3 w-3" /> {enrolled ? 'Refaire mon empreinte vocale avec cette réunion' : 'Créer mon empreinte vocale avec cette réunion'}
      </button>
      {asking && (
        <span className="absolute left-0 top-full z-20 mt-2 block w-80 rounded-xl border border-slate-200 bg-white p-3 text-xs text-slate-600 shadow-lg">
          <span className="block">
            Tes {Math.round(info.seconds)} secondes de parole seule dans cette réunion servent à calculer ton empreinte, sur le Mac ;
            seule l'empreinte est gardée.
          </span>
          <label className="mt-2 flex items-start gap-2">
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" />
            <span>{info.consent_text}</span>
          </label>
          <span className="mt-3 flex items-center justify-end gap-2">
            <button type="button" onClick={() => setAsking(false)} className="rounded-lg px-2 py-1 text-slate-500 hover:bg-slate-100">Annuler</button>
            <button type="button" onClick={send} disabled={!consent || state === 'sending'}
              className="flex items-center gap-1 rounded-lg bg-violet-600 px-2.5 py-1 font-semibold text-white disabled:opacity-40">
              {state === 'sending' && <Loader2 className="h-3 w-3 animate-spin" />} Créer l'empreinte
            </button>
          </span>
          {state && state !== 'sending' && <span className="mt-2 block text-rose-600">{state}</span>}
        </span>
      )}
    </span>
  );
};

export default VoiceFromMeeting;
